export default __webpack_public_path__ + "static/media/sanmat13.fadb79d5.jpg";